// Arbeitgeber-Freitexte: die Bestandsnamen, die noch keiner Firma zugeordnet
// sind. Seit 08/2026 wird der Arbeitgeber als Firmenkontakt verknüpft, nicht
// mehr getippt — dieser Dienst liefert die Arbeitsgrundlage, um die Altdaten
// nachzuziehen.

import { apiUrl } from "../utils/api";

export interface ArbeitgeberFreitextGruppe {
  /** Der Text, wie er im Bestand steht. */
  name: string;
  /** Wie viele Personen ihn tragen. */
  anzahl: number;
  /** Stichprobe der Personen (höchstens 12). */
  personen: Array<{ id: number; name: string }>;
}

export async function ladeArbeitgeberFreitexte(): Promise<ArbeitgeberFreitextGruppe[]> {
  const res = await fetch(apiUrl("contact/arbeitgeber-freitext"));
  if (!res.ok) throw new Error(`Laden fehlgeschlagen (${res.status})`);
  const daten = await res.json();
  return Array.isArray(daten) ? daten : [];
}

/**
 * Ordnet allen Personen mit diesem Freitext dieselbe Firma zu und räumt den
 * Text weg. Liefert, wie viele Personen betroffen waren.
 */
export async function ordneArbeitgeberZu(name: string, firmaId: number): Promise<number> {
  const res = await fetch(apiUrl("contact/arbeitgeber-freitext/zuordnen"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, firmaId }),
  });
  if (!res.ok) throw new Error(`Zuordnen fehlgeschlagen (${res.status})`);
  const daten = await res.json().catch(() => null);
  return Number(daten?.zugeordnet ?? 0);
}
